import React from "react";
import { CalendarToday, MoreVert } from "@mui/icons-material";
import { Button, IconButton, Menu, MenuItem, Paper, Toolbar, Typography } from "@mui/material";
import EventoFormDialog from "./EventoFormDialog";
import EventoEscolhaPopover from "./EventoEscolhaPopover";

export default function CalendarioActionMenu(props) {
    const {type, data, eventos, action} = props;

    const [openForm, setOpenForm] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [anchorElEscolheEvento, setAnchorElEscolheEvento] = React.useState(null);
    const [evento, setEvento] = React.useState(null);

    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    function handleEvento(e){
        console.log( e );
        setEvento(e);
        setOpenForm(true);
    }

    return (
        <React.Fragment>            
            <IconButton 
                color="primary" aria-label="Ações"
                onClick={handleClick}
            >
                <MoreVert />
            </IconButton>
                
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                slotProps={{
                    list: {
                        'aria-labelledby': 'basic-button',
                    },
                }}
            >
                <MenuItem 
                    onClick={(e)=> {
                            setAnchorElEscolheEvento(e.currentTarget)
                            handleClose();
                        }
                    }
                >
                    Editar
                </MenuItem>
                <MenuItem onClick={() =>{
                    setOpenForm(true);
                    setEvento();
                    handleClose();
                }}>
                    Novo Evento
                </MenuItem>
                
                <MenuItem onClick={handleClose}>Remover Evento</MenuItem>                
            </Menu>
            <EventoEscolhaPopover 
                anchorEl={anchorElEscolheEvento} setAnchorEl={setAnchorElEscolheEvento} 
                type={type} data={data} eventos={eventos}
                onEventoEscolhido={handleEvento}
            />
            <EventoFormDialog 
                action={action} closeMenu={handleClose} open={openForm} setOpen={setOpenForm}
                eventoRoot={evento}
            />
        </React.Fragment>
    )
}